import React, { useEffect, useState } from 'react';

import '../../Styles/InternshipProgram.css';

const introductionImages = [
  'https://ncgsa.org.pk/wp-content/uploads/2026/01/11-1200x900.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2026/01/10-1200x900.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2026/01/09.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2026/01/01.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2026/01/06-1200x900.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2026/01/02-1200x900.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2026/01/03.jpg',
  'https://ncgsa.org.pk/wp-content/uploads/2026/01/05-1200x900.jpg',
];

const IntroductionComponent = () => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = window.setInterval(
      () => setCurrentImage((current) => (current + 1) % introductionImages.length),
      3000,
    );
    return () => window.clearInterval(interval);
  }, []);

  return (
    <div className="internship-introduction-section">
      <div className="internship-introduction-inner">
      <header className="internship-introduction-copy">
        <p className="section-eyebrow">START YOUR JOURNEY</p>
        <h1>Introduction</h1>
        <div className="internship-title-line" aria-hidden="true" />
        <p>
          The NCGSA Summer Internship Program, at Institute of Space Technology (IST), Islamabad
          is an annual, hands-on learning opportunity for students passionate about space science
          and technology. The program immerses participants in cutting-edge domains of Space
          Science and Technology, equipping them with essential skills and exposure to support
          their future careers in the space sector.
        </p>
      </header>

        <div className="internship-introduction-carousel" aria-label="NCGSA internship program gallery">
          <figure>
            <img
              key={introductionImages[currentImage]}
              src={introductionImages[currentImage]}
              alt={`NCGSA Summer Internship Program activity ${currentImage + 1}`}
            />
          </figure>
          <button
            type="button"
            className="internship-intro-arrow previous"
            aria-label="Show previous image"
            onClick={() => setCurrentImage((current) => (current - 1 + introductionImages.length) % introductionImages.length)}
          >‹</button>
          <button
            type="button"
            className="internship-intro-arrow forward"
            aria-label="Show next image"
            onClick={() => setCurrentImage((current) => (current + 1) % introductionImages.length)}
          >›</button>
          <div className="internship-intro-dots">
            {introductionImages.map((image, index) => (
              <button
                type="button"
                key={image}
                className={index === currentImage ? 'active' : ''}
                aria-label={`Show internship image ${index + 1}`}
                onClick={() => setCurrentImage(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroductionComponent;
